// Skickar besök och händelser till Skyland Command Center, så att sajten kan
// följas i Gustavs kundkort. Samma väg som skylandai.se och marinmekaniker.nu.
//
// Sajtnyckeln ligger i webbläsaren och är därför ingen hemlighet. Mottagaren
// kontrollerar att anropet kommer från coldexperience.se innan den skriver.
const BAS = 'https://scc.skylandai.se/api/v1/webhooks/site';
const SAJTNYCKEL = 'sk_264000ecf31540e9aa16037c169c1249';
const NYCKEL_SESSION = 'scc_session';

const sessionId = () => {
  try {
    let id = sessionStorage.getItem(NYCKEL_SESSION);
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) || null;
      if (!id) return null;
      sessionStorage.setItem(NYCKEL_SESSION, id);
    }
    return id;
  } catch {
    return null;
  }
};

const posta = (vag, kropp) => {
  // keepalive gör att händelsen hinner iväg även om klicket byter sida.
  fetch(`${BAS}/${vag}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ site_key: SAJTNYCKEL, ...kropp }),
    keepalive: true,
  }).catch(() => { /* spårning får aldrig störa sajten */ });
};

let sessionStartad = false;

/** Kallas en gång per besök, och sedan vid varje sidbyte. */
export const sparBesok = (sprak) => {
  const session_uuid = sessionId();
  if (!session_uuid) return;

  if (!sessionStartad) {
    sessionStartad = true;
    posta('session-init', {
      session_uuid,
      user_agent: navigator.userAgent,
      entry_module: window.location.pathname,
    });
  }

  const events = [{ type: 'page_view', data: { sida: window.location.pathname } }];
  // Sajten finns på fyra språk. Vilket besökaren kommer in på är värt att veta.
  if (sprak) events.push({ type: 'lang', data: { lang: String(sprak).slice(0, 5) } });

  posta('track-event', { session_uuid, events });
};

/** Kallas vid stegen som säger något om köpviljan. */
export const sparHandelse = (type, data = {}) => {
  const session_uuid = sessionId();
  if (!session_uuid) return;
  posta('track-event', { session_uuid, events: [{ type, data }] });
};

/**
 * Skickar sjalva gasten till SCC:s leadmottagare, inte bara telemetri.
 * Fristaende fran sajtens egen backend: gar den ner ska gasten anda hamna
 * i Gustavs CRM.
 *
 * consent_given far ALDRIG skickas som true utan att gasten faktiskt kryssat
 * i en samtyckesruta. Mottagaren avvisar anropet utan den.
 */
export const sparLead = (lead) => {
  posta('ce-lead', { session_uuid: sessionId() || undefined, ...lead });
};
